import { useEffect } from "react";
import { getTranslateByKey } from "@/main/services/utils";
import * as S from "./styles";
import { supervisionAssignmentFilterRequest } from "@/main/models/request/supervisionAssignment";
import SecondaryButton from "../../button/secondaryButton";
import KogInputTextControlledNew from "../../inputText/inputTextControlledNew";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { useForm } from "react-hook-form";

interface ISearchBodyshopProps {
	guidCompany: string;
	isLoad: boolean;
	OnSearch: (filters: supervisionAssignmentFilterRequest) => void;
	OnClear: () => void;
	resetTrigger: number;
}

function SearchBodyshop({ guidCompany, isLoad, OnSearch, OnClear, resetTrigger }: ISearchBodyshopProps) {
	const INITIAL_FORM_STATE_SEARCH = {
		bodyshopName: "",
		bodyshopRfc: "",
		intialPostalCode: "",
		finalPostalCode: "",
	};

	type IBodyshopFormSearch = typeof INITIAL_FORM_STATE_SEARCH;

	const methods = useForm<IBodyshopFormSearch>({
		mode: "onChange",
		defaultValues: INITIAL_FORM_STATE_SEARCH,
	});
	const { control, getValues, reset, handleSubmit } = methods;

	function clearFieldsBySearch() {
		OnClear();
		reset(INITIAL_FORM_STATE_SEARCH);
	}

	function onSubmit() {
		const request: supervisionAssignmentFilterRequest = {
			guidCompany: guidCompany,
			bodyshopName: getValues().bodyshopName || "",
			bodyshopRfc: getValues().bodyshopRfc || "",
			intialPostalCode: getValues().intialPostalCode || "",
			finalPostalCode: getValues().finalPostalCode || "",
			pageIndex: 1,
			pageSize: PaginationEnum.PageSize15,
		};

		OnSearch(request);
	}

	useEffect(() => {
		reset(INITIAL_FORM_STATE_SEARCH);
	}, [resetTrigger]);

	return (
		<form onSubmit={handleSubmit(onSubmit)} noValidate>
			<S.ContainerHeaderGrid>
				<KogInputTextControlledNew
					id="id-bodyshop-name-input"
					label={getTranslateByKey("information.bodyshop")}
					name="bodyshopName"
					inputProps={{ maxLength: 250 }}
					control={control}
				/>

				<KogInputTextControlledNew
					id="id-bodyshop-rfc-input"
					label={getTranslateByKey("information.rfc")}
					name="bodyshopRfc"
					inputProps={{ maxLength: 30 }}
					control={control}
				/>

				<KogInputTextControlledNew
					id="id-bodyshop-initial-code-input"
					label={getTranslateByKey("information.initialZipCode")}
					hasOnlyNumberInteger
					name="intialPostalCode"
					inputProps={{ maxLength: 50 }}
					control={control}
				/>

				<KogInputTextControlledNew
					id="id-bodyshop-final-code-input"
					label={getTranslateByKey("information.finalZipCode")}
					name="finalPostalCode"
					hasOnlyNumberInteger
					inputProps={{ maxLength: 50 }}
					control={control}
				/>

				<S.AreaButtons>
					<SecondaryButton id="id-SupervisionAssingnment-btn-clear" isLoading={isLoad} onClick={clearFieldsBySearch}>
						{getTranslateByKey("information.clear")}
					</SecondaryButton>

					<SecondaryButton id="id-SupervisionAssingnment-button-search" isLoading={isLoad} type="submit">
						{getTranslateByKey("information.search")}
					</SecondaryButton>
				</S.AreaButtons>
			</S.ContainerHeaderGrid>
		</form>
	);
}

export default SearchBodyshop;
